import React from 'react'
import ClusterDetail from '../oam/components/cluster-detail/ClusterDetail'


export interface Props {

}
const  CollegeClusterDetail:React.FC<Props> = (props) => {
  return (
    <div>
        <ClusterDetail mode={"college-oam"}/>
    </div>
  )
}

export default CollegeClusterDetail